/**
 * Tools Booking Detail page for endusers
 * Uses shared BookingDetail component
 */
import { createRoute } from '@tanstack/react-router'
import { toolsRoute } from '../index'
import { BookingDetail } from '@/components/bookings'

function ToolsBookingDetailPage() {
  const { accessId } = toolsBookingDetailRoute.useParams()

  return (
    <BookingDetail
      accessId={accessId}
      backRoute="/tools/bookings"
    />
  )
}

export const toolsBookingDetailRoute = createRoute({
  getParentRoute: () => toolsRoute,
  path: '/bookings/$accessId',
  component: ToolsBookingDetailPage,
})
